import { Props } from '../../../types';
import { html } from 'lit-html';

export const cardBody = (props: Props) => {
  const { children, className, style } = props;
  return html`
    <div class=${className || ''} style=${style || ''}>${children}</div>
  `;
};
